import { create } from 'zustand';
import { getOrganizationsDict } from '../../../api/api';

const getOrganizationName = (item) => item?.username ?? '';

const toList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

export const useOrganizationsDictStore = create((set, get) => ({
  organizationsById: {},
  isLoading: false,

  fetchOrganizations: async () => {
    if (get().isLoading || Object.keys(get().organizationsById).length > 0) return;

    set({ isLoading: true });

    await getOrganizationsDict({
      dataCb: (data) => {
        const organizationsById = Object.fromEntries(toList(data).map((item) => [item.id, getOrganizationName(item)]));
        set({ organizationsById, isLoading: false });
      },
      errCb: () => {
        set({ isLoading: false });
      },
    });
  },
}));
